<script setup lang="ts">
import { useI18n } from "vue-i18n";

import Dropdown from "@/dsComponents/Dropdown/Dropdown.vue";

const { t } = useI18n();
</script>

<template>
    <Dropdown mode="hover" width="fit-content" :styles="{ padding: 'var(--spacing-xs, 4px) var(--spacing-md, 8px)' }">
        <template #trigger-zone>
            <i class="ti ti-alert-triangle-fill worker-incomplete-registration-alert-icon" />
        </template>
        <template #dropdown-content>
            <span class="typo-xxs-regular worker-incomplete-registration-alert-tooltip">
                {{ t("page.companyNeed.recruitment.alerts.incompleteRegistration") }}
            </span>
        </template>
    </Dropdown>
</template>

<style scoped lang="scss">
.worker-incomplete-registration-alert-icon {
    color: var(--red-base, #e51940);
    font-size: 14px;
    line-height: 1;
    display: inline-flex;
}

.worker-incomplete-registration-alert-tooltip {
    color: var(--text-sub-600, #494e61);
    white-space: nowrap;
}
</style>
